<template>

<!--    <div class="text-subtitle2" v-html="field.label"></div>-->
    <div class="text-body2" v-html="field.description"></div>

</template>

<script>
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },

  methods: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),

  },
  mounted() {

  }
}
</script>
